import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";
import {RouteComponent} from "../-routeComponent";
import {getAdminWorkspacesWithCaching} from "../-queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/workspace/")({
    loader: async ({context}) => {
        const workspaces = await getAdminWorkspacesWithCaching({
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        });

        return {
            workspaces,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
